// The contents of this file is code generated so do not
// change anything in here

import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as MerchantSVG } from '../../Assets/Icons/Merchant.svg';

export const Merchant = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 22 22" {...props}>
    <MerchantSVG />
  </SvgIcon>
);
